import classNames from "classnames";

interface TableSortLabelProps {
  className?: string;
  active: boolean;
  direction: "asc" | "desc";
  labelOffset?: number;
  children: React.ReactNode;
}

export function TableSortLabel(props: TableSortLabelProps) {
  const { className, active, direction, labelOffset = 0, children } = props;

  return (
    <div className={classNames("relative", className)}>
      {active && (
        <div
          className={classNames("absolute w-full h-[2px] rounded-[1px] bg-accent-blue-400")}
          style={{
            ...(direction === "asc" && { top: `calc(-${labelOffset}px)` }),
            ...(direction === "desc" && { bottom: `calc(-${labelOffset}px)` }),
          }}
        />
      )}
      {children}
    </div>
  );
}
